<template>
    <toles-application-layout>
        <b-card
            :title="$t('sign_up').toUpperCase()"
            class="mb-2"
        >
    <ValidationObserver ref="registerForm">
            <b-row>
                <b-col sm="12" md="6" lg="6">
                    <ValidationProvider name="name"  rules="required" v-slot="{ valid,errors }">
                        <b-form-group :label="$t('name')">
                            <b-form-input size="sm"   :state="errors[0] ? false : (valid ? true : null)"
                                          v-model="form.name" class="rounded-lg"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12"  lg="6" md="6">
                    <ValidationProvider name="surname" rules="required" v-slot="{valid, errors }">
                        <b-form-group :label="$t('surname')">
                            <b-form-input size="sm"
                                          v-model="form.surname"
                                          class="rounded-lg"
                                          :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12"  lg="6" md="6">
                    <ValidationProvider name="tc_no"  rules="required" v-slot="{valid, errors }">
                        <b-form-group :label="$t('tc_no')">
                            <b-form-input size="sm" v-model="form.national_id"
                                          v-mask="'###########'"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          class="rounded-lg" ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12"  lg="6" md="6">
                    <ValidationProvider name="gsm_no" rules="required" v-slot="{valid, errors }">
                        <b-form-group :label="$t('gsm_no')">
                            <b-form-input size="sm"
                                          v-mask="'(5##)-###-####'"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          v-model="phone"
                                          class="rounded-lg"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12"  lg="6" md="6">
                    <ValidationProvider name="gender"
                                        rules="required"
                                        v-slot="{valid, errors}">
                        <b-form-group :label="$t('gender')">
                            <gender-selectbox
                                :validate-error="errors[0]"
                                v-model="form.gender">
                            </gender-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12"  lg="6" md="6">
                    <ValidationProvider name="email" rules="required|email" v-slot="{valid, errors }">
                        <b-form-group :label="$t('email')">
                            <b-form-input size="sm" v-model="form.email" class="rounded-lg" :state="errors[0] ? false : (valid ? true : null)" ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12"  lg="6" md="6">
                    <ValidationProvider name="same_university" rules="required" v-slot="{valid,errors}">
                        <b-form-group :label="$t('toles_application_form_bau_question')">
                            <YesNoSelectbox v-model="same_university"  :state="errors[0] ? false : (valid ? true : null)" :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <template v-if="same_university==='E'">
                    <b-col sm="12" lg="6" md="6">
                        <ValidationProvider name="student_number" :rules="same_university==='E'?'required':''"  v-slot="{valid,errors}">
                            <b-form-group :label="$t('student_number')">
                                <b-form-input size="sm" v-model="form.student_number" class="rounded-lg" :state="errors[0] ? false : (valid ? true : null)" ></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="6" md="6">
                        <ValidationProvider name="same_university_email" :rules="same_university==='E'?'required|bau_email':''" v-slot="{valid,errors}">
                            <b-form-group :label="$t('bau_email')">
                                <b-form-input size="sm" v-model="form.same_university_email" class="rounded-lg" :state="errors[0] ? false : (valid ? true : null)" ></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                </template>

            </b-row>
          </ValidationObserver>
            <b-col class="d-flex flex-column justify-content-center align-item-center">
                <ProcessingButton class="d-flex justify-content-center mt-4"  :processing="loading"  :label="$t('send_verification_code')" @click="sendVerify" />
                <b-button variant="link" class="mt-3" @click="$router.push('/toles/application/login')">{{ $t('login') }}</b-button>
            </b-col>
        </b-card>

        <CommonModal ref="emailVerification" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="clear">
            <template v-slot:CommonModalTitle>
                <template>
                    {{ $t('email_verification').toUpper() }}
                </template>
            </template>
            <template v-slot:CommonModalContent>
                <div class="mb-3">
                    <div class="alert alert-info">
                        <strong>{{ form.email }}</strong>
                    </div>
                    <ValidationObserver ref="formSmsVerify">
                        <ValidationProvider name="pin" rules="required" v-slot="{valid, errors}">
                            <sms-input v-model="pin"
                                       :timerFrom="timer"
                                       @timerExpired="timerExpired"
                            />
                        </ValidationProvider>


                    </ValidationObserver>
                    <div class="d-flex justify-content-end mt-2">
                        <ProcessingButton v-if="timer===0" :label="$t('resend_code')" :variant="'link'" :processing="loading" @click="sendVerify"/>
                    </div>
                    <div>
                        <ProcessingButton v-if="timer>0" :disabled="pin==null"  :label="$t('verify')" :processing="loading" class="d-flex justify-content-center align-item-center mt-3" @click="verify"/>
                    </div>
                </div>
            </template>
        </CommonModal>



    </toles-application-layout>
</template>
<script>
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import TolesApplicationLayout from "@/layouts/TolesApplicationLayout.vue";
import TolesApplicationServices from "@/services/TolesApplicationServices";
import SmsInput from "@/components/elements/SmsInput.vue";
export default {
    components: {
        SmsInput,
        TolesApplicationLayout,
        ProcessingButton
    },
    data(){
        return {
            form:{},
            phone:null,
            same_university:null,
            loading: false,
            disabled:true,
            pin:null,
            timer:0
        }
    },
    created() {
        const tolesUser =localStorage.getItem('toles_application_user')?JSON.parse(localStorage.getItem('toles_application_user')):null;
        const pin =localStorage.getItem('pin')?JSON.parse(localStorage.getItem('pin')):null
        const sessionExpiryTime =localStorage.getItem('sessionExpiryTime')?JSON.parse(localStorage.getItem('sessionExpiryTime')):null
        if (tolesUser ||pin || sessionExpiryTime){
            this.logout()
        }
    },

    methods:{
        clear(){

        },
        timerExpired(event) {
            this.timer = 0;
        },
        async sendVerify(){
            const isValid =await this.$refs.registerForm.validate()
            if (!isValid)return
            try {
                this.form.same_university=this.same_university==='E'?1:0
                this.form.phone=this.phone.replaceAll('-','').replaceAll('(','').replaceAll(')','')
                const res = await TolesApplicationServices.register(this.form)
                this.timer=res.data.data.express_in

                this.$refs.emailVerification.$refs.commonModal.show()
                this.$toast.success('api.'+res.data.data.message)
            }catch (error) {
                if (error.data.message==='APPLICATION_ALREADY_PENDING'){
                      this.$router.push('/toles/application/login')
                }
                this.showErrors(error,this.$refs.registerForm)
            }
        },
        async verify(){
            const isValid = this.$refs.formSmsVerify.validate()
            if (!isValid)return
            try {
                const data ={
                    national_id:this.form.national_id,
                    pin:this.pin
                }
                const res = await TolesApplicationServices.verify(data)
                this.$store.dispatch('TolesApplicationStore/setTolesApplicationUser',res.data.data)
                this.$store.dispatch('TolesApplicationStore/setPin',this.pin)
                this.$toast.success(this.$t('registration_successful'))
                this.$router.push('/toles/application/form')
            }catch (err){
                this.showErrors(err,this.$refs.formSmsVerify)
            }

        },
        logout(){
            this.$store.dispatch('TolesApplicationStore/logout')
        }
    }
}
</script>

<style scoped>

</style>
